// eslint-disable-next-line import/prefer-default-export
export const eventNamePrefix = 'UD-';
//# sourceMappingURL=constants.js.map